import { useCallback, useContext } from 'react';
import { AppContext } from 'contexts';
import { useLocalStorage } from '../helpers/hooks';

const freshState = {
  isLoggedIn: null,
  isOnboarded: null,
  isSubscribed: null,
  isConfirmed: null,
  isRegisteredInCore: null,
  email: null,
  id: null,
  vendorUUID: null,
  vendors: null,
  firstName: null,
  lastName: null,
  subscriptionId: null,
  stripeCustomerId: null,
  timezone: null,
  apiRegions: [],
};

const useProvideApp = () => {
  const [value, setValue] = useLocalStorage('APP', freshState);

  const onOnboardingComplete = useCallback(() => {
    setValue(prev => ({ ...prev, isOnboarded: true }));
  }, [setValue]);

  const onLoginSuccess = useCallback(
    user =>
      setValue(prev => ({
        ...prev,
        ...user,
        isLoggedIn: true,
      })),
    [setValue]
  );

  const onLogoutSuccess = useCallback(() => {
    setValue({ ...freshState });
  }, [setValue]);

  const onTimezoneUpdated = useCallback(
    timezone => {
      setValue(prev => ({ ...prev, timezone }));
    },
    [setValue]
  );

  return {
    ...value,
    onLoginSuccess,
    onLogoutSuccess,
    onOnboardingComplete,
    onTimezoneUpdated,
  };
};

export const AppProvider = props => {
  const app = useProvideApp();

  return <AppContext.Provider value={app} {...props} />;
};

export const useApp = () => {
  return useContext(AppContext);
};

export default AppProvider;
